module.exports = __webpack_public_path__ + "img/addidas_preview.67b0f901.webp";